export const ACTION_SHARE_GROUP = 'ACTION_SHARE_GROUP';
export const ACTION_RENAME_GROUP = 'ACTION_RENAME_GROUP';
export const ACTION_DELETE_GROUP = 'ACTION_DELETE_GROUP';
